// NoProducts.tsx
import React from 'react';
import noProduct from '../../assets/images/noProduct.png';

const NoProducts: React.FC = () => {
  return (
    <div style={styles.container}>
      <h2 style={styles.title}>No Products Found</h2>
      <p style={styles.subtitle}>
        We're sorry, but there are currently no products available.
      </p>
      <img src={noProduct} alt="No Products" style={styles.image} />
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '70vh',
    textAlign: 'center',
    padding: '20px',
  },
  title: {
    fontSize: '2rem',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '1rem',
    marginBottom: '20px',
    color: '#777',
  },
  image: {
    width: '300px',
    height: 'auto',
    objectFit: 'contain',
    opacity: 0.7,
  },
};

export default NoProducts;
